import { render, staticRenderFns } from "./meta-information-table.vue?vue&type=template&id=2438295c"
import script from "./meta-information-table.vue?vue&type=script&lang=js"
export * from "./meta-information-table.vue?vue&type=script&lang=js"
import style0 from "./meta-information-table.vue?vue&type=style&index=0&id=2438295c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports